import { Method } from '../types';

const common = [
  Method.WineBrett,
  Method.WineConz,
  Method.WineConzViab,
  Method.WineManualCnt,
  Method.Yeast2Brett,
  Method.Yeast2Conz,
  Method.Yeast2ConzViab,
];

export const InputToMethodMap = {
  name: common,
  description: common,
  dilutionSample1: common,
  dilutionSample2: common,
  density: [Method.WineConz, Method.WineConzViab],
  turbidity: [Method.WineConz, Method.WineConzViab],
  temperature: [
    Method.WineConz,
    Method.WineConzViab,
    Method.Yeast2Brett,
    Method.Yeast2Conz,
    Method.Yeast2ConzViab,
    Method.BioEthConz,
    Method.BioEthConzViab,
  ],
  ph: [
    Method.Yeast2Brett,
    Method.Yeast2Conz,
    Method.Yeast2ConzViab,
    Method.BioEthConz,
    Method.BioEthConzViab,
  ],
  dilutionStain1: [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab],
  dilutionStain2: [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab],
};

/**
 * This function responsible for conditional input rendering in the create-analysis-modal
 */
export const shouldRenderInput = ({
  input,
  method,
}: {
  input: keyof typeof InputToMethodMap;
  method: Method;
}) => {
  return InputToMethodMap[input].includes(method);
};
